<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Add User Name -->
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("common.add") }} {{ $t("operation.user") }}</h2>
            <br />
          </b-col>
        </b-row>
        <div v-if="showUserInfo">
          <b-row>
            <b-col md="6">
              <b-form-group :label="$t('common.name')">
                <b-form-input
                  v-model="addForm.name"
                  :placeholder="$t('common.name')"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group :label="$t('operation.email')">
                <b-form-input
                  v-model="addForm.email"
                  :placeholder="$t('operation.email')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12">
              <b-form-group :label="$t('operation.password')">
                <b-form-input
                  v-model="addForm.password"
                  :placeholder="$t('operation.password')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12">
              <b-form-group :label="$t('warehouse.department')">
                <AutoComplete
                  :placeholder="`${$t('common.select')} ${$t(
                    'warehouse.department'
                  )}`"
                  v-model="addForm.department_id"
                  param-query="search"
                  :serializer="(val) => val.id"
                  endpoint="departments"
                  text-title="name"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Add Button -->
          <b-row>
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-end mt-5 mb-1 mb-md-0"
            >
              <b-button variant="primary" @click="addNewItem()" block>
                {{ $t("common.add") }} {{ $t("operation.user") }}
              </b-button>
            </b-col>
          </b-row>
        </div>
        <div v-if="!showUserInfo">
          <b-row>
            <b-col cols="12" md="12">
              <h5>{{ $t("operation.choose-role") }}</h5>
              <AutoComplete
                :label="$t('operation.roles')"
                :placeholder="`${$t('common.select')} ${$t('operation.role')}`"
                v-model="roleIds"
                param-query="search"
                :serializer="(val) => val"
                endpoint="role"
                text-title="name"
              />
            </b-col>
          </b-row>
          <div class="d-flex gap-2">
            <b-button
              class="mx-1"
              variant="primary"
              v-for="roule in selectedRouls"
              :key="roule.id"
              @click="removeRoule(roule.id)"
            >
              {{ roule.name }}
            </b-button>
          </div>
          <b-row>
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-end mt-1 mb-1 mb-md-0"
            >
              <b-button variant="primary" @click="addRole()">
                {{ $t("common.submit") }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BLink,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BModal,
  VBModal,
  BCardText,
  BFormCheckboxGroup,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BLink,
    BDropdown,
    BDropdownItem,
    BTooltip,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BCardText,
    BFormCheckbox,
    BFormCheckboxGroup,
    AutoComplete,
  },
  data() {
    return {
      addForm: {
        name: "",
        username: "",
        phone: "",
        email: "",
        department_id: "",
      },
      roleIds: [],
      option: [],
      params: {
        form: {},
        path: "",
      },
      params2: {
        form: {},
        path: "",
      },

      permissionForm: {
        permissionsIds: [],
      },
      user_id: "",
      RoleList: [],
      roleSelected: "",
      PermissionList: [],
      departmentList: [],
      jobTitleList: [],
      showUserInfo: true,
      showUserRole: false,
      selectedRouls: [],
    };
  },
  watch: {
    roleIds() {
      if (this.roleIds.id) {
        this.selectedRouls.push(this.roleIds);
      }
    },
  },
  methods: {
    addNewItem() {
      this.addForm.name = this.addForm.name;
      (this.params.form = this.addForm),
        (this.params.path = "/user"),
        this.$store
          .dispatch("create", this.params)
          .then((resp) => {
            console.log(resp);
            this.user_id = resp.data.data.id;
            this.showUserInfo = false;
            this.showUserRole = true;
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "User Created",
                icon: "success",
                variant: "info",
                text:
                  "User " +
                  this.addForm.name +
                  " Created Successfully Please Choose Their Role and Permission",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    addRole() {
      const rouls = this.selectedRouls.map((x) => x.id);
      (this.params2.form = { roleIds: rouls }),
        (this.params2.path = `/assign-role-to/user/${this.user_id}`),
        this.$store
          .dispatch("create", this.params2)
          .then(() => {
            if (this.permissionForm.permissionsIds.length) {
              this.addPermission();
            } else {
              this.$router.push({ name: "users" });
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "User Info Completed",
                  icon: "success",
                  variant: "info",
                  text: "User " + this.addForm.name + " Completed Successfully",
                },
              });
            }
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    removeRoule(id) {
      this.selectedRouls = this.selectedRouls.filter((x) => x.id !== id);
    },
    // addPermission() {
    //   (this.params.form = this.permissionForm),
    //     (this.params.path = `/add/permission/user/${this.user_id}`),
    //     this.$store
    //       .dispatch('create', this.params)
    //       .then(() => {
    //         this.$router.push({ name: 'users' });
    //         this.showUserInfo = true;
    //         this.showUserRole = false;
    //         this.$toast({
    //           component: ToastificationContent,
    //           position: 'top-right',
    //           props: {
    //             title: 'User Info Completed',
    //             icon: 'success',
    //             variant: 'info',
    //             text: 'User ' + this.addForm.name + ' Completed Successfully',
    //           },
    //         });
    //       })
    //       .catch((error) => {
    //         if (error.response.status === 400) {
    //           for (let item in error.response.data) {
    //             this.$toast({
    //               component: ToastificationContent,
    //               position: 'top-right',
    //               props: {
    //                 title: 'validation error',
    //                 variant: 'danger',
    //                 text: error.response.data[item][0],
    //               },
    //             });
    //           }
    //         }
    //       });
    // },
  },
};
</script>
<style scoped>
.modify_checkbox {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  row-gap: 30px;
  column-gap: 5px;
}

.custom-checkbox {
  width: 18rem;
  height: 3rem;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
